import { call, put, select, takeLeading } from 'redux-saga/effects'
import createManualAssignation from 'api/administration/applications/AssignManually'
import { IEnrolModel } from 'models/enrol.model'

import * as fromActions from '../../actions/enrols.action'
import { ErrorToast } from '../../../components/ui/toast/toastsTemplates'
import I18n from '../../../i18n'
import { IMainState } from '../../states'

async function createManuallyEnrol(data: IEnrolModel, userIds) {
  return await createManualAssignation(data, userIds)
}

function* enrolCreateManuallyEffectSaga(
  action: fromActions.EnrolCreateManuallyAction
) {
  try {
    const {
      payload: { enrol, userIds },
    } = action

    const { data: getEnrol }: { data: any } = yield call(
      createManuallyEnrol,
      enrol,
      userIds
    )
    yield put(fromActions.Actions.enrolCreateManuallyAssignedSuccess(getEnrol))

    interface Params {
      sort: any[]
      courseId: number | undefined
    }

    yield select(
      ({ monitoring: { sort }, courses: { course } }: IMainState): Params => ({
        sort,
        courseId: course.id,
      })
    )
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.genericError'))
    console.error(error)
  }
}

export function* enrolCreateManuallyWatcherSaga() {
  yield takeLeading(
    fromActions.ENROL_CREATE_MANUALLY_ASSIGNED,
    enrolCreateManuallyEffectSaga
  )
}
